module.exports = __webpack_public_path__ + "img/step2-4.3a13eae7.png";